// being used

import React, { useContext, useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import PPEFormComponent from "./formComponent";

import HistoryIcon from "@mui/icons-material/History";
import {
  Dialog,
  DialogContent,
  Grid,
  Select,
  TextField,
  IconButton,
} from "@material-ui/core";

import { getFacilities } from "../../../service/endpoint-manager";
import clsx from "clsx";
import { FormControl, MenuItem } from "@mui/material";

import styles from "../../../styles.module.css";
// import { getHistoryListFromStorage } from "../../../utils/helperFunctions";
import { PPE_HISTORY } from "../../../types/micellinous-constants";
import { viewportContext } from "../../../context/ViewportContext";

const PPEForm = () => {
  const { screenType } = useContext(viewportContext);
  const user = JSON.parse(localStorage.getItem("user-profile"));

  const username = user.userName;

  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [allPayloads, setAllPayloads] = useState([]);

  // Fetch facility for filters
  useEffect(() => {
    const getData = async () => {
      try {
        let response = await getFacilities();
        if (response.data.status) {
          const firstFacility = response.data.body[0];
          setFacilities(response.data.body);
          setSelectedFacility(firstFacility);

          if (firstFacility && firstFacility.units) {
            setUnits(firstFacility.units);
            setSelectedUnit(firstFacility.units[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching facilities and units: ", error);
      }
    };
    getData();
  }, []);

  const handleFacilityChange = (event) => {
    const selectedFacilityId = event.target.value;

    const selectedFacility = facilities.find(
      (facility) => facility.name === selectedFacilityId
    );

    setSelectedFacility(selectedFacility);

    if (selectedFacility && selectedFacility.units) {
      setUnits(selectedFacility.units);
      setSelectedUnit(selectedFacility.units[0]);
    }
  };

  const handleUnitChange = (event) => {
    const selectedUnitId = event.target.value;
    const selectedUnit = units.find((unit) => unit.id === selectedUnitId);
    setSelectedUnit(selectedUnit);
  };

  const handleOpenHistoryDialog = () => {
    // setAllPayloads(getHistoryListFromStorage(PPE_HISTORY));
    // setOpenHistoryDialog(true);
  };

  const handleCloseHistoryDialog = () => {
    setOpenHistoryDialog(false);
  };

  return (
    <div>
      <Dialog
        open={openHistoryDialog}
        onClose={handleCloseHistoryDialog}
        maxWidth="md"
        className={styles.dialogStylesPpeHistory}
      >
        <DialogContent>
          <Typography variant="h5">Audit History</Typography>
          {allPayloads?.map((payload, payloadIndex) => (
            <div key={payloadIndex}>
              <pre>
                <Typography variant="h6">History {payloadIndex + 1}</Typography>
                <b>Nurse:</b> {payload.nurse} {`\n`}
                <b>Facility:</b> {payload.facility} {`\n`}
                <b>Unit:</b> {payload.unit} {`\n`}
                <b>Health Care Worker:</b> {payload.healthCareWorker} {`\n`}
                {payload.formQuestions.map((form, formIndex) => (
                  <div key={formIndex}>
                    <b>Step Title:</b> {form.stepTitle} {`\n`}
                    <b>Questions:</b>
                    {form.questions.map((question, questionIndex) => (
                      <div key={questionIndex}>
                        {`\n`}
                        &nbsp;&nbsp;&nbsp; Question: {question.question}
                        {`\n`}
                        &nbsp;&nbsp;&nbsp; Response: {question.response.value}
                        {`\n`}
                        {question.response.outcomeExists && (
                          <div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Outcome Type:{" "}
                            {question.response.outcome.type}
                            {`\n`}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Outcome Value:{" "}
                            {question.response.outcome.value}
                          </div>
                        )}
                      </div>
                    ))}
                    {`\n`}
                  </div>
                ))}
              </pre>
            </div>
          ))}
        </DialogContent>
      </Dialog>
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{
          marginBottom: "2rem",
          marginTop: "2rem",
          position: "relative",
        }}
        className={styles.whiteBackgroundBox}
      >
        <Grid item xs={12} sm={4}>
          <div className="select-field">
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4} sm={4}>
                <label htmlFor="facilitySelect">Nurse:</label>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  required
                  fullWidth
                  id="userName"
                  name="userName"
                  autoComplete="userName"
                  value={username}
                  variant="outlined"
                  disabled
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12} sm={4} className={styles.flexCenter}>
          <p className={styles.labelDetailStyles}>Facility</p>
          <FormControl variant="outlined" style={{ width: "80%" }}>
            {selectedFacility && (
              <Select
                variant="outlined"
                option={facilities}
                value={selectedFacility?.name}
                className={clsx(`${styles.dropdown} ${styles.flexLeft}`)}
                onChange={handleFacilityChange}
              >
                {facilities?.map((facility) => {
                  return (
                    <MenuItem
                      key={selectedFacility?.name}
                      value={selectedFacility ? selectedFacility.name : ""}
                      selected={selectedFacility?.name}
                      className={clsx(`${styles.flexLeft}`)}
                    >
                      {selectedFacility?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4} className={styles.flexCenter}>
          <p className={styles.labelDetailStyles}>Unit</p>
          <FormControl variant="outlined" style={{ width: "80%" }}>
            <Select
              variant="outlined"
              disabled={!selectedFacility}
              option={units}
              defaultValue={null}
              className={clsx(`${styles.dropdown} ${styles.flexLeft}`)}
              onChange={handleUnitChange}
              value={selectedUnit ? selectedUnit.id : ""}
            >
              {units?.map((unit) => {
                return (
                  <MenuItem
                    key={unit?.id}
                    value={unit?.id}
                    selected={unit?.name}
                    className={clsx(`${styles.flexLeft}`)}
                  >
                    {unit?.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        {/* <IconButton
          onClick={handleOpenHistoryDialog}
          className={clsx(styles.historyButton)}
        >
          <HistoryIcon />
        </IconButton> */}
      </Grid>

      <div
        style={{ display: "flex", flexDirection: "row", textAlign: "center" }}
      >
        {screenType.isTab || screenType.isMobile ? (
          <div style={{ flex: 1, padding: "10px" }}>
            <PPEFormComponent
              selectedFacility={selectedFacility}
              selectedUnit={selectedUnit}
              nurse={user.user_id}
              allPayloads={allPayloads}
              setAllPayloads={setAllPayloads}
            />
          </div>
        ) : (
          <>
            <div style={{ flex: 1, padding: "10px" }}>
              <PPEFormComponent
                selectedFacility={selectedFacility}
                selectedUnit={selectedUnit}
                nurse={user.user_id}
                allPayloads={allPayloads}
                setAllPayloads={setAllPayloads}
              />
            </div>
            <div style={{ flex: 1, padding: "10px" }}>
              <PPEFormComponent
                selectedFacility={selectedFacility}
                selectedUnit={selectedUnit}
                nurse={user.user_id}
                allPayloads={allPayloads}
                setAllPayloads={setAllPayloads}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PPEForm;
